import React from 'react'

import { ButtonV2, Icon, Menu, MenuControl, MenuProvider, Text } from '@vividseats/vivid-ui-kit'
import type { MenuOptionType as Option } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import MenuBody from './components/menu/menu-body'
import MenuOption from './components/menu/menu-body/menu-option'
import styles from './styles.module.scss'

interface Props {
    classes?: {
        menuBody?: string
    }
    handleChange: (option: any) => void
    handleTrackClick: () => void
    options: Option[]
    selectedOption: Option
    isChanged?: boolean
}

const Filter: React.FC<Props> = ({ classes, handleChange, handleTrackClick, options, selectedOption, isChanged }) => {
    const btnClassname = classNames(styles.filterButton, {
        [styles.isChanged]: !!isChanged,
    })
    return (
        <MenuProvider onChange={handleChange} options={options}>
            <Menu className={styles.menu}>
                <MenuControl>
                    <ButtonV2 className={btnClassname} onClick={handleTrackClick}>
                        <div className={styles.filterButtonText}>
                            <Text altFont className={styles.filterOptionText}>
                                {selectedOption.label}
                            </Text>
                            <Icon className={styles.dropdownIcon} type="dropdown" />
                        </div>
                    </ButtonV2>
                </MenuControl>
                <MenuBody classes={{ desktop: classNames(styles.menuBody, classes?.menuBody) }}>
                    {options.map((option, i) => {
                        return (
                            <MenuOption key={`${option.value}-${i}`} value={option.value}>
                                <div
                                    className={classNames(styles.optionWrapper, {
                                        [styles.selectedOption]: option.value === selectedOption.value,
                                    })}
                                >
                                    <Text altFont className={styles.filterOptionText}>
                                        {option.label}
                                    </Text>
                                </div>
                            </MenuOption>
                        )
                    })}
                </MenuBody>
            </Menu>
        </MenuProvider>
    )
}

export default Filter
